import { Injectable } from '@angular/core';
import { IOnboardingEditItem } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import {
    IOnboardingCompletionData,
    IOnboardingCompletionSaveModel,
} from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { promise } from 'protractor';

@Injectable()
export class FiOnboardingCompletionService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getOnboardingCompletionData(onboardingId: number) {
        return this.fiBackend.fetchData<IOnboardingCompletionData>(
            `Onboarding/Onboarding/GetOnboardingCompletionData/${onboardingId}`,
        );
    }

    saveOnboardingCompletion(
        saveCompletionModel: IOnboardingCompletionSaveModel,
    ): Promise<IOnboardingCompletionSaveModel> {
        const promise: Promise<IOnboardingCompletionSaveModel> =
            this.fiBackend.fetchDataPost<IOnboardingCompletionSaveModel>(
                `Onboarding/Onboarding/SaveOnboardingCompletion`,
                saveCompletionModel,
            );
        return this.fiLoading.trackPromise(promise);
    }
}
